import axios from "axios";
import { APIHandler } from "../base";

export const fetchUser = () => APIHandler.get("/users/current");

export const fetchUsers = () => APIHandler.get("/users?pageSize=1000");

export const updateUser = (firebaseId: string) =>
    APIHandler.patch("/users/current", { firebaseId });

export const updateUserKB = (currentKnowledgeBaseId: string) =>
    APIHandler.patch("/users/current", { currentKnowledgeBaseId });

// P3-08 web selection: "All assistants" binds the company orchestrator;
// null clears back to the current assistant's specialist.
export const updateUserAgent = (currentAgentUid: string | null) =>
    APIHandler.patch("/users/current", { currentAgentUid });

export const fetchAgentPicker = () => APIHandler.get("/users/current/agent-picker");

export const getProviderUser = (url: string, token: string) =>
    axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

export const getGoogleUser = (token: string) =>
    getProviderUser("https://www.googleapis.com/drive/v3/about?fields=user", token);

export const getMSUser = (token: string) =>
    getProviderUser("https://graph.microsoft.com/v1.0/me", token);
